export * from './actionCreators'
import { userReducer } from './reducer'

export interface IUserState {
    id: string;
    name: string;
    email: string;
    isPendingEmail: boolean;
    subscriptions: string[];
}

export default userReducer;


// WEBPACK FOOTER //
// ./src/store/modules/user/index.ts